module.exports = __webpack_public_path__ + "img/node-layer.d2fd69ee.svg";